import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { awaitAllSafely } from '@vy/utils';
import { queryKeys } from '../../services/query-key/query-keys';

type DisconnectIntegrationInput = {
  integrationId: string;
};

export function useDisconnectIntegration(
  options?: UseMutationOptions<void, unknown, DisconnectIntegrationInput>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ integrationId }) => {
      const api = getPrivateApi();
      
      return api.disconnectIntegration({
        integrationId,
      });
    },
    ...options,
    onSuccess: async () => {
      await awaitAllSafely(
        queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
        queryClient.invalidateQueries(queryKeys.integrationSettings()),
      );
    },
  });
} 